// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c5fc2f08","453":"9149e7a6"}[chunkId] + ".chunk.js";
};